<template>
  <div class="h-auto ml-0 w-full lg:mr-3 min-h-screen">
    <!-- <ProfileCompletion></ProfileCompletion> -->
    <div class="grid lg:grid-cols-3 grid-cols-1">
      <div class="col-span-1">
        <for-my-action></for-my-action>
      </div>
      <div class="col-span-2">
        <div
          class="grid grid-cols-1 gap-3 my-3 lg:mx-0 mx-3"
          :class="
            getUserRole.toLowerCase() === 'hrmanager'
              ? 'lg:grid-cols-3'
              : 'lg:grid-cols-2'
          "
        >
          <clock-in></clock-in>
          <today-at-glance
            v-if="getUserRole.toLowerCase() === 'hrmanager'"
          ></today-at-glance>

          <announcement></announcement>
        </div>
        <div class="grid lg:grid-cols-2 grid-cols-1 gap-2.5">
          <celebration></celebration>
          <upcoming-event></upcoming-event>
        </div>
        <div class="grid grid-cols-1 gap-3 my-3 lg:mx-0 mx-3">
          <!-- <tasks></tasks> -->
          <leave-balances></leave-balances>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ForMyAction from "@/components/dashboard/forMyAction.vue";
import ClockIn from "@/components/dashboard/clockIn.vue";
import TodayAtGlance from "@/components/dashboard/todayAtGlance.vue";
import Announcement from "@/components/dashboard/announcement.vue";
//import Tasks from "@/components/dashboard/Tasks.vue";
import LeaveBalances from "@/components/dashboard/leaveBalances.vue";
import UpcomingEvent from "@/components/dashboard/upcomingEvents.vue";
// import ProfileCompletion from "@/components/dashboard/profileCompletion.vue";
import axios from "axios";
import { mapGetters } from "vuex";
import Celebration from "@/components/dashboard/celebrations.vue";

export default {
  name: "Dashboard",
  data() {
    return {};
  },
  components: {
    ForMyAction,
    ClockIn,
    TodayAtGlance,
    Announcement,
    // Tasks,
    LeaveBalances,
    UpcomingEvent,
    // ProfileCompletion,
    Celebration,
  },
  created() {
    this.getTeamLeaves();
  },
  computed: {
    ...mapGetters([
      "getUserRole",
      "getToken",
      "getCurrentEmployeeId",
      "getOrganization",
      "getUserToView",
    ]),
  },
  methods: {
    getTeamLeaves() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          accept: "*/*",
        },
      };

      axios
        .get(
          `${this.getOrganization}/timeoff/myteam/${this.$ApiVersion}/request`,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.status === 200) {
              this.$emit("closeOnSuccess");

              // Create an object to store unique items based on Id
              const uniqueItems = {};

              // Filter and keep only unique items based on Id
              response.data.Data.forEach((item) => {
                uniqueItems[item.Id] = item;
              });

              // Convert the object back to an array of objects
              this.tableData = Object.values(uniqueItems).filter(
                (d) => d.LeaveType !== "Test"
              );
              this.tableData = this.tableData.filter(
                (d) => d.Status !== "Pending"
              );

              // this.getNumberOfAbscentEmployees(this.tableData);
            } else {
              this.get_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.get_error = error.message;
          }
        );
    },

    getNumberOfAbscentEmployees(data) {
      // Get the current date without time
      const currentDate = new Date();
      currentDate.setHours(0, 0, 0, 0);

      // Function to check if a date is within a range (ignoring time)
      function isDateInRange(date, startDate, endDate) {
        const start = new Date(startDate);
        start.setHours(0, 0, 0, 0);

        const end = new Date(endDate);
        end.setHours(0, 0, 0, 0);

        // return date >= start && date <= end;
        return start >= date && end <= date;
      }

      let absentCount = 0;

      data.forEach((entry) => {
        if (isDateInRange(currentDate, entry.StartDate, entry.EndDate)) {
          absentCount++;
        }
      });

      absentCount;
    },
    approveLeave({ Id, Reason }) {
      const data = {
        Id,
        Reason: Reason,
        Status: "Approved",
      };
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          "Content-Type": "application/json",
        },
      };
      this.showApprovalWarning = false;

      axios
        .post(
          `${this.getOrganization}/timeoff/${this.$ApiVersion}/process`,
          JSON.stringify(data),
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.$emit("closeOnSuccess");
              this.getTeamLeaves();
              this.tableData = response.data.Data;
              this.message = response.data.StatusMessage;
              setTimeout(() => {
                this.isApproved = true;
                this.message = null;
              }, 3000);
            } else {
              this.create_error = response.data.StatusMessage;
              setTimeout(() => {
                this.create_error = null;
              }, 3000);
            }
          },
          (error) => {
            this.loading = false;
            this.create_error = error.message;
            setTimeout(() => {
              this.create_error = null;
            }, 3000);
          }
        );
    },
  },
};
</script>
